import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataTypeOptions } from '@core/constants/data-types.constants';
import { CurrencyExchange } from '@core/models/currency-exchange';
import { InsuranceTarget } from '@core/models/insurance-target.model';
import { GroupCoverage, ProductCoverage } from '@core/models/product-coverage.model';
import { Product } from '@core/models/product.model';
import { LanguageService } from '@i18n/services/language.service';
import { getFieldError, isFieldInvalid, isFieldValid } from '@shared/utils/forms/validations.util';

@Component({
  selector: 'mfp-product-feature-group-coverage',
  templateUrl: './product-feature-group-coverage.component.html',
  styleUrls: ['./product-feature-group-coverage.component.scss']
})
export class ProductFeatureGroupCoverageComponent implements OnInit {
  @Input() coverages!: ProductCoverage[];
  @Input() insuranceTarget!: InsuranceTarget;
  @Input() product!: Product;
  @Input() currencyExchange!: CurrencyExchange;
  @Input() disabled = true;
  @Input() placeholder = '';
  @Output() coverageChange = new EventEmitter<ProductCoverage>();

  isFieldValid = isFieldValid;
  isFieldInvalid = isFieldInvalid;
  getFieldError = getFieldError;

  values: DataTypeOptions<string> = [];
  groupCoverages?: GroupCoverage[];

  constructor(private language: LanguageService) {}
  ngOnInit() {
    const filteredCoverages = this.coverages.reduce((previous, current) => {
      if (current.group) {
        previous[current.group] = previous[current.group] || [];
        previous[current.group].push(current);
      }
      return previous;
    }, Object.create(null));

    this.groupCoverages = Object.keys(filteredCoverages).map(key => {
      return {
        group: key,
        coverages: filteredCoverages[key],
        selectedCoverage:
          filteredCoverages[key].filter((value: ProductCoverage) => {
            return value.active;
          })[0] || filteredCoverages[key][0]
      };
    });
  }

  onCoverageChange(event: ProductCoverage) {
    this.coverageChange.emit(event);
  }
}
